export default __webpack_public_path__ + "static/media/267.6492e674.jpg";